import React from 'react';
import { Container } from 'reactstrap';

import '../style/Home.css';

const Home = (): JSX.Element => (
  <Container fluid className="main-container">
    <a
      href="/cadcraft/index.html"
      className="btn btn-primary go-to-configuration-button"
    >
      Go to Cadcraft version
    </a>
  </Container>
);

export default Home;
